import React from 'react';
import { BrowserRouter, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import './App.css';
import SessionRibbon from './components/SessionRibbon';
import Hub from './screens/Hub';
import Scorecard from './screens/Scorecard';
import FirstPlayer from './screens/FirstPlayer';
import Dice from './screens/Dice';
import Timer from './screens/Timer';
import Rounds from './screens/Rounds';

export function Layout() {
  const location = useLocation();
  const showRibbon = location.pathname !== '/';

  return (
    <div className="app">
      {showRibbon && <SessionRibbon />}
      <Outlet />
      <footer className="app-footer">
        <a href={`${process.env.PUBLIC_URL || ''}/privacy.html`} target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Hub />} />
          <Route path="scorecard" element={<Scorecard />} />
          <Route path="first-player" element={<FirstPlayer />} />
          <Route path="dice" element={<Dice />} />
          <Route path="timer" element={<Timer />} />
          <Route path="rounds" element={<Rounds />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
